<template>
    <div
        class="bg-next-gray-md mb-3 md:flex md:min-w-1000 items-start p-3 gap-3"
    >
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Denominazione</span>
            <span>{{ c.denominazione }}</span>
        </div>
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Settore commerciale</span>
            <span>{{ c.settori_join }}</span>
        </div>
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Stato</span>
            <div
                class="min-w-285 grid gap-1 mt-1"
                :style="{
                    'grid-template-columns': `repeat(${businessUnits.length}, minmax(0, 1fr))`,
                }"
            >
                <div v-for="bu in businessUnits" class="" :key="bu.id">
                    <div
                        class="px-2 border border-next-neu rounded text-center text-xs"
                    >
                        {{ bu.label }}
                    </div>
                    <div
                        :class="`bg-next-${getColoriStati(c.stati[bu.id])}`"
                        class="px-2 border rounded text-center text-xs text-white"
                    >
                        {{ getLabel(c.stati[bu.id]) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Ultimo contatto</span>
            <span>{{ $filters.toDateTime(c.ultimo_contatto) }}</span>
        </div>
        <div class="basis flex flex-col self-center">
            <NextButton
                variant="outline-secondary"
                component="router-link"
                :to="{ name: 'DettaglioAzienda', params: { id: c.id } }"
                class="sm:block py-1 px-3"
            >
                Vedi
            </NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { ColoriStati, LabelStati } from "@/types";
import NextButton from "@/components/NextButton.vue";

@Options({
    name: "ClientiSearchResult",
    components: { NextButton },
    props: {
        c: {
            type: Object,
            default: () => ({}),
        },
        businessUnits: {
            type: Array,
            default: () => [],
        },
    },
})
export default class ClientiSearchResult extends Vue {
    c!: any;
    businessUnits!: any[];

    getColoriStati(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return ColoriStati[ColoriStati.neu];
        }
        return ColoriStati[EnumStato];
    }

    getLabel(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return LabelStati[LabelStati.NEU];
        }
        return LabelStati[EnumStato];
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
